import Loader from 'components/Loader';
import { lazy, Suspense } from 'react';
import { FeatureFlag } from 'types/features';
import { NumericIdGuard } from 'utils/route-guard/NumericIdGuard.tsx';
import { ProtectedRoute } from './ProtectedRoute.tsx';

export const MEETING_PREP_VIEW_PATH = 'ai-chat/meeting-prep/:messageId';

/**
 * The brief is an optional report reachable only from an AI chat message, so the page and its
 * ~20 section modules are split into an async chunk instead of riding in the startup bundle.
 * Exported so the route element's composition can be asserted by identity.
 */
export const MeetingPrepViewPageLazy = lazy(() =>
    import('pages/meeting-prep/MeetingPrepViewPage').then((module) => ({ default: module.MeetingPrepViewPage }))
);

/**
 * Factored out of `MainRoutes.tsx` so it can be imported without pulling in that file's
 * top-level `NotFoundPage` import, which circularly re-imports `MainRoutes` through
 * `useSearchableRoutes.ts` and breaks module resolution in the test environment.
 */
export const meetingPrepViewRouteElement = (
    <ProtectedRoute
        redirectPath="/"
        element={
            <NumericIdGuard paramName="messageId">
                <Suspense fallback={<Loader />}>
                    <MeetingPrepViewPageLazy />
                </Suspense>
            </NumericIdGuard>
        }
        permissions={['READ.CRESPECT_AI']}
        requiredFeature={FeatureFlag.AI_CHAT_ENABLED}
    />
);
